module.exports = __webpack_public_path__ + "img/RN.78346596.png";